import {
  apiLsClientVariable,
  countryWithIso,
  getTokenData,
  isMobileDevice,
} from "./utils";
import localStorageService from "./localStorage";

export const sendClickEvent = (eventName, eventProperties = {}) => {
  if (window.amplitude) {
    const eventData = {};
    let session = localStorageService.get(apiLsClientVariable);
    if (session) {
      session = session ? JSON.parse(window.atob(session)) : null;
      const { user: userData, sub: userId } = getTokenData(session.token);
      Object.assign(eventData, {
        country: countryWithIso(userData.whatsapp_country.iso),
        user_id: userId,
        email: userData.email,
        phone_number: userData.whatsapp,
      });
    }
    Object.assign(eventData, {
      device_type: isMobileDevice() ? "mobile" : "desktop",
      referral_source: "desconocido",
    });

    Object.assign(eventData, eventProperties);

    // Enviar a Amplitude
    window.amplitude.logEvent(eventName, eventData);
  } else {
    console.warn("Amplitude is not initialized");
  }
};
